module.exports = __webpack_public_path__ + "static/media/opes-logo-big.aff1473c.png";